<template>
	<div id="settlementCenter">
		<page-header title="审核中心">
			<el-select v-model="queryForm.status" placeholder="审核状态" size="small" @change="onClickRadioStatus">
				<el-option v-for="item in statusList" :key="item.value"
					:label="`${item.label}${statusCounts[item.value] ? ' ('+statusCounts[item.value]+')' : ''}`"
					:value="item.value" />
			</el-select>
			<el-input clearable v-model="queryForm.projectName" placeholder="项目名称" size="small" />
			<el-input clearable v-model="queryForm.supplierName" placeholder="供应商" size="small" />
			<el-input clearable v-model="queryForm.fullName" placeholder="负责人" size="small" />
			<el-input clearable v-model="queryForm.applicationForm" placeholder="申请单号" size="small" />
			<el-input clearable v-model="queryForm.reimbursementNum" placeholder="报销单号" size="small" />
			<el-input clearable v-model="queryForm.clearingBuyerName" placeholder="结算负责人" size="small" />
			<el-button type="primary" size="small" icon="el-icon-search" @click="onSearch">查询</el-button>
			<el-button size="small" icon="el-icon-refresh" @click="reSet">重置</el-button>
		</page-header>

		<!-- 数据表格 -->
		<el-table :data="dataList" border style="width: 100%" v-loading="loading" size="small" class="settlement-table">
			<el-table-column align="center" prop="id" label="编号" width="65" />
			<el-table-column align="left" prop="projectName" label="项目名称" min-width="180" show-overflow-tooltip />
			<el-table-column align="center" prop="clearingBuyerName" label="结算负责人" width="100" />
			<el-table-column align="center" prop="fullName" label="项目负责人" width="100" />
			<el-table-column align="center" prop="supplierName" label="供应商" min-width="130" show-overflow-tooltip />
			<el-table-column align="center" prop="applicationForm" label="申请单号" width="130" show-overflow-tooltip />
			<el-table-column align="center" prop="reimbursementNum" label="报销单号" width="130" show-overflow-tooltip />
			<el-table-column align="center" label="发起时间" width="100">
				<template slot-scope="scope">
					{{ $moment(scope.row.createTime).format('MM/DD HH:mm') }}
				</template>
			</el-table-column>
			<el-table-column align="center" prop="applyMoney" label="金额(元)" width="90" />
			<el-table-column align="center" label="超预算" width="70">
				<template slot-scope="scope">
					<el-tag v-if="isValidOverBudget(scope.row.isOverBudget)" size="mini"
						:type="isOverBudget(scope.row) ? 'danger' : 'success'" disable-transitions>
						{{ isOverBudget(scope.row) ? '是' : '否' }}
					</el-tag>
				</template>
			</el-table-column>
			<el-table-column align="center" label="收款方式" width="90">
				<template v-slot:default="scope">
					{{ shortCollectWay(scope.row.collectWay) }}
				</template>
			</el-table-column>
			<el-table-column align="center" label="状态" width="90">
				<template v-slot:default="scope">
					<el-tag size="mini" :type="statusTagType(scope.row.status)">
						{{ statusLabel(scope.row.status) }}
					</el-tag>
				</template>
			</el-table-column>
			<el-table-column label="操作" width="160" fixed="right" align="center">
				<template slot-scope="scope">
					<el-button size="mini" type="text"
						@click="toDetails(scope.row)">{{ scope.row.status=='OFFICIAL_EXAMINE'|| scope.row.status=='REJECTED' ?'审核':'查看' }}</el-button>
					<el-button v-if="scope.row.reimbursementNum" size="mini" type="text"
						@click="toJdCloud(scope.row.id)">金蝶</el-button>
					<el-button v-if="scope.row.reimbursementNum && scope.row.status!='FINISH'" size="mini" type="text"
						@click="syncKingdeeStatus(scope.row.id)">同步</el-button>
					<el-button v-if="scope.row.reimbursementNum && scope.row.status=='FINISH'" size="mini" type="text"
						@click="syncPaymentDate(scope.row.id)">付款日期</el-button>
				</template>
			</el-table-column>
		</el-table>

		<!-- 分页 -->
		<div class="pagination-wrap">
			<TablePaging :currentPage="queryForm.current" :total="queryForm.total" :pageSize="queryForm.size"
				@pageChange="handleCurrentChange" />
		</div>
	</div>
</template>

<script>
import {
	getSpendingOrderListByPage, fetchStatusCounts, redirctUrl, kingdeeStatus, syncPaymentDate
} from '@/request/api.js';
import TablePaging from '@/components/TablePaging.vue';
import PageHeader from '@/components/PageHeader.vue';

export default {
	name: 'settlementCenter',
	components: { TablePaging, PageHeader },
	data() {
		return {
			statusCounts: [],
			statusList: [
				{ label: '全部', value: 'ALL' },
				{ label: '待审核', value: 'OFFICIAL_EXAMINE' },
				{ label: '官员已通过', value: 'OFFICIAL_APPROVED' },
				{ label: '官员驳回', value: 'ERROR' },
				{ label: '财务审核中', value: 'SUBMIT' },
				{ label: '财务驳回', value: 'REJECTED' },
				{ label: '审核通过', value: 'APPROVED' },
				{ label: '已推金蝶', value: 'K3_PUSHED' },
				{ label: '已打款', value: 'FINISH' },
			],
			collectWayEnums: {
				"0": "一次性结项", "1": "首次收款", "2": "阶段收款", "3": "尾款", "4": "据实结算",
			},
			queryForm: {
				current: 1, size: 10, total: 0, status: "ALL", projectTimeRange: []
			},
			dataList: [],
			loading: false,
		}
	},
	mounted() {
		this.loadData();
		this.fetchStatusCounts();
	},
	methods: {
		statusLabel(s) {
			const map = {
				'OFFICIAL_EXAMINE': '待审核', 'OFFICIAL_APPROVED': '官员已通过',
				'APPROVED': '审核通过', 'SUCCESS': '审核通过',
				'SUBMITTED': '已提交', 'SUBMIT': '财务审核中',
				'AI_REVIEW_SUCCESS': 'AI预审中', 'K3_PUSHED': '已推金蝶',
				'FINISH': '已打款', 'REJECTED': '财务驳回', 'ERROR': '官员驳回',
				'DRAFT': '草稿'
			};
			return map[s] || s;
		},
		statusTagType(s) {
			const map = {
				'OFFICIAL_EXAMINE': 'warning', 'OFFICIAL_APPROVED': 'success',
				'APPROVED': 'success', 'SUCCESS': 'success',
				'SUBMITTED': '', 'SUBMIT': '', 'K3_PUSHED': '',
				'FINISH': 'success', 'ERROR': 'danger', 'REJECTED': 'danger',
				'DRAFT': 'info'
			};
			return map[s] || 'info';
		},
		shortCollectWay(val) {
			return this.collectWayEnums[val] || '-';
		},
		isValidOverBudget(val) {
			return val !== null && val !== undefined && val !== '';
		},
		isOverBudget(row) {
			return [true, 1, '1', 'true'].includes(row.isOverBudget);
		},
		fetchStatusCounts() {
			fetchStatusCounts().then(res => {
				if (res.code == 200) {
					const countMap = {};
					(res.data || []).forEach(item => { countMap[item.status] = item.total; });
					this.statusCounts = countMap;
				}
			})
		},
		onClickRadioStatus() {
			this.queryForm.current = 1;
			this.loadData();
		},
		toDetails(item) {
			this.$router.push({ name: 'fileListPreviewnew', query: { orderId: item.id } });
		},
		toJdCloud(orderId) {
			this.$confirm(
				'<div>即将跳转至金蝶云星空系统。</div>' +
				'<div style="margin-top: 8px; color: #f56c6c; font-weight: bold;">⚠️ 操作完成后请返回本系统点击"同步"按钮。</div>',
				'操作提醒',
				{ dangerouslyUseHTMLString: true, confirmButtonText: '继续', cancelButtonText: '取消', type: 'warning' }
			).then(() => {
				redirctUrl({ orderId }).then(res => {
					if (res.code === 200) window.open(res.data, '_blank');
					else this.$message.error(res.msg || '跳转失败');
				});
			}).catch(() => {});
		},
		syncPaymentDate(orderId) {
			this.$confirm('确定同步金蝶付款日期？', '提示', {
				confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning'
			}).then(() => {
				syncPaymentDate({ orderId }).then(res => {
					if (res.code === 200) { this.$message.success('同步成功'); this.loadData(); }
					else this.$message.error(res.msg || '同步失败');
				});
			}).catch(() => {});
		},
		syncKingdeeStatus(orderId) {
			this.$confirm('确定同步金蝶报销单状态？', '提示', {
				confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning'
			}).then(() => {
				kingdeeStatus({ orderId }).then(res => {
					if (res.code === 200) { this.$message.success('同步成功'); this.loadData(); this.fetchStatusCounts(); }
					else this.$message.error(res.msg || '同步失败');
				});
			}).catch(() => {});
		},
		onSearch() { this.queryForm.current = 1; this.loadData(); },
		reSet() {
			this.queryForm = { current: 1, size: 10, total: 0, status: "ALL" };
			this.loadData();
		},
		handleCurrentChange(val) { this.queryForm.current = val; this.loadData(); },
		loadData() {
			this.loading = true;
			const params = { ...this.queryForm };
			if (params.status == 'ALL') delete params.status;
			getSpendingOrderListByPage(params).then(res => {
				if (res.code == 200) {
					this.dataList = res.data.records;
					this.queryForm.total = res.data.total;
				}
				this.loading = false;
			}).catch(() => { this.loading = false; });
		},
	}
}
</script>

<style lang="scss" scoped>
#settlementCenter {
	padding: 16px;

	.filter-bar {
		background: #fff;
		padding: 12px 16px;
		border-radius: 8px;
		margin-bottom: 12px;
		border: 1px solid #ebeef5;

		.filter-inputs {
			display: flex;
			gap: 8px;
			flex-wrap: wrap;
			align-items: center;

			.status-select { width: 160px; }
			.el-input { width: 120px; }
		}
	}

	.settlement-table {
		border-radius: 8px;
		overflow: hidden;
	}

	.pagination-wrap {
		margin-top: 12px;
		display: flex;
		justify-content: center;
	}
}
</style>

<style lang="scss">
.el-table .warning-row { background: oldlace; }
.el-table .success-row { background: #f0f9eb; }
</style>
